import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import PAYMENT_REFUND_PAYER from '../../components/constants/paymentRefundPayer';

const PackerDeliveryOrderBatchRefundItem = ({ refundOrderItem, removeRefundOrderItem, updateRefundOrderItem }) => {
  const onRefundPayerChange = () => {
    const newRoi = { ...refundOrderItem };
    if (refundOrderItem.payer === PAYMENT_REFUND_PAYER.producer) {
      newRoi.payer = PAYMENT_REFUND_PAYER.membo;
    } else {
      newRoi.payer = PAYMENT_REFUND_PAYER.producer;
    }

    updateRefundOrderItem(newRoi);
  };

  const isPaidByProducer = refundOrderItem.payer === PAYMENT_REFUND_PAYER.producer;

  return (
    <div className="m-b-1">
      <span className="m-r-2">
        {refundOrderItem.amount}€{' '}
        {refundOrderItem.amount !== refundOrderItem.orderItem.itemPrice ? (
          <small className="">/ {refundOrderItem.orderItem.itemPrice}€</small>
        ) : (
          ''
        )}{' '}
        - {refundOrderItem.orderItem.itemName}
      </span>{' '}
      <FontAwesomeIcon onClick={() => removeRefundOrderItem()} className="m-r-3" icon={faMinusCircle} />
      <input
        name="refundPayer"
        type="checkbox"
        className="m-r-1"
        checked={isPaidByProducer}
        onChange={onRefundPayerChange}
      />
      <small className={isPaidByProducer ? '' : 'text-muted'} onClick={onRefundPayerChange}>
        <FormattedMessage id={'packer.delivery.order.batch.row.refunds.refund.on.behalf.of.producer'} />
      </small>
    </div>
  );
};

PackerDeliveryOrderBatchRefundItem.propTypes = {
  refundOrderItem: PropTypes.object.isRequired,
  removeRefundOrderItem: PropTypes.func.isRequired,
  updateRefundOrderItem: PropTypes.func.isRequired,
};

PackerDeliveryOrderBatchRefundItem.defaultProps = {};

export default PackerDeliveryOrderBatchRefundItem;
